import type {EditStatuses} from '../types';
import {removeById} from './removeById';

export function removeEditStatus(
  id: string,
  editStatuses: EditStatuses,
): EditStatuses {
  return removeById(id, editStatuses);
}
